import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-MWTXJ44116";
export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};